import React, {useState} from "react";
import styles from "./Checkbox.module.scss";
import {isTouchDevice} from "../../../../helpers/deviceInformation";

type ChechboxProps = {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
  wrapperClassName?: string;
  color?: string;
};

const Checkbox: React.FC<ChechboxProps> = ({
  children,
  checked = false,
  onChange,
  className = "",
  wrapperClassName = "",
  color = "#0db700",
}) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      className={[styles.checkboxWrapper, wrapperClassName].join(" ")}
      onMouseOver={() => {
        setIsHover(true);
      }}
      onMouseLeave={() => {
        setIsHover(false);
      }}
    >
      <label>
        <input
          type="checkbox"
          checked={checked}
          onChange={(evt) => {
            if (onChange) {
              onChange(evt.target.checked);
            }
          }}
        />
        <div className={`${styles.checkboxDiv} ${className}`}>
          {checked && (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 36" width={"20px"} height={"20px"}>
              <path fill={color} d="M13.91 33.81L.91 20.8l3.42-3.42 9.58 9.58L39.03 1.85l3.42 3.42-28.54 28.54z" />
            </svg>
          )}
          {!checked && isHover && !isTouchDevice() && (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 36" width={"20px"} height={"20px"}>
              <path fill={"#dddddd"} d="M13.91 33.81L.91 20.8l3.42-3.42 9.58 9.58L39.03 1.85l3.42 3.42-28.54 28.54z" />
            </svg>
          )}
        </div>
        <div className={styles.childrenWrapper}>{children}</div>
      </label>
    </div>
  );
};

export default Checkbox;
